import { createContext, useContext } from "react";
import { RootStore } from "./rootStore";

const StoreContext = createContext<RootStore | undefined>(undefined);

interface StoreProviderProps {
  children: React.ReactNode;
}

const rootStore = new RootStore();

export const StoreProvider = ({ children }: StoreProviderProps) => <StoreContext.Provider value={rootStore}>
  {children}
</StoreContext.Provider>


export const useStore = () => useContext(StoreContext);